(() => {
  const SELECTOR = '.trustpilot-widget[data-trustpilot-lazy="true"]';

  const canLoadTrustpilot = () =>
    window.Trustpilot &&
    typeof window.Trustpilot.loadFromElement === 'function';

  const markLoaded = el => {
    el.dataset.trustpilotLoaded = 'true';
  };

  const isLoaded = el => el.dataset.trustpilotLoaded === 'true';

  const loadWidget = el => {
    if (!el || isLoaded(el)) return;
    if (!canLoadTrustpilot()) return;
    try {
      window.Trustpilot.loadFromElement(el, true);
      markLoaded(el);
    } catch (e) {
      // no-op; Trustpilot can throw if called during bootstrap 
    }
  };

  const tryLoadWithRetry = (el, attempts = 0) => {
    if (!el || isLoaded(el)) return;
    if (canLoadTrustpilot()) {
      loadWidget(el);
      return;
    }
    if (attempts >= 20) return; // ~5s
    window.setTimeout(() => tryLoadWithRetry(el, attempts + 1), 250);
  };

  const init = () => {
    const widgets = Array.from(document.querySelectorAll(SELECTOR));
    if (!widgets.length) return;

    if (!('IntersectionObserver' in window)) {
      widgets.forEach(el => tryLoadWithRetry(el));
      return;
    }

    const io = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          io.unobserve(el);
          tryLoadWithRetry(el);
        });
      },
      { rootMargin: '250px 0px' }
    );

    widgets.forEach(el => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

